<p-table #dt [value]="commonFacilityData" [rows]="rows" styleClass="p-datatable-striped p-datatable-gridlines"
[paginator]="true" sortMode="multiple" [lazy]="true" (onLazyLoad)="lazyLoadSchedules($event)"
responsiveLayout="scroll" [rowHover]="true" dataKey="Id" [totalRecords]="totalRecords" [columns]="cols"
currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [resetPageOnSort]="false"
[showCurrentPageReport]="true" [rowsPerPageOptions]="[10,15,25,50,totalRecords]"
[globalFilterFields]="['FacilityName']" [resizableColumns]="false">
<ng-template pTemplate="header">
  <tr [ngStyle]="isAccessRead?{'pointer-events': 'none'} : {'pointer-events': 'all'}">
    <th pSortableColumn="FacilityName" style="width:92%" pResizableColumn>Facility Name
      <p-sortIcon field="FacilityName"></p-sortIcon>
    </th>
    <th>Action</th>
  </tr>
</ng-template>
<ng-template pTemplate="body" let-qualityGoal>
  <tr>
    <td>
      {{qualityGoal.FacilityName}}
    </td>
    <td *ngIf="standerdProcessBool">

      <p-image 
        src="../../../../../../../assets/images/pre-implement.png" alt="Image" class="mr-2 prepost-implement"
        pTooltip="Pre Implementation" tooltipPosition="left" width="20px"
        (click)="implementationBool = true;implementationName = 'Pre Implementation';showStanderdProcessPre(qualityGoal.FacilityID,qualityGoal.FacilityName)">
      </p-image>

      <p-image 
        src="../../../../../../../assets/images/post-implement.png" alt="Image" class="mr-2 prepost-implement"
        pTooltip="Post Implementation" tooltipPosition="left" width="20px"
        (click)="implementationBool = true;implementationName = 'Post Implementation';showStanderdProcessPost(qualityGoal.FacilityID,qualityGoal.FacilityName)">
      </p-image>

    </td>
    <td *ngIf="facilityBool">
      <a class="no-underline"
        (contextmenu)="onContextMenu($event,qualityGoal.FacilityID,qualityGoal.FacilityName,'Edit')">
        <button *ngIf="isAccessReadWrite && !isAccessRead && !roleForFacility" pButton pRipple icon="pi pi-pencil"
          pTooltip="Edit Facility Specifics" tooltipPosition="left" class="p-button-rounded p-button-primary mr-2"
          (click)="getFacilityDetailByFacilityId(qualityGoal.FacilityID,qualityGoal.FacilityName);onContextMenuPreventDefault($event)"></button>
      </a>
      <a class="no-underline flex"
        (contextmenu)="onContextMenu($event,qualityGoal.FacilityID,qualityGoal.FacilityName,'View')">
        <button *ngIf="(!isAccessReadWrite && isAccessRead) || roleForFacility" pButton pRipple icon="pi pi-eye" pTooltip="View"
          tooltipPosition="bottom" class="p-button-rounded  p-button-primary mr-2"
          (click)="getFacilityDetailByFacilityId(qualityGoal.FacilityID,qualityGoal.FacilityName);onContextMenuPreventDefault($event)"></button>
      </a>
    </td>

  </tr>
</ng-template>
<ng-template pTemplate="emptymessage" let-columns>
  <tr>
    <h5 *ngIf="totalRecords==0" class="text-center create-roles">
      <b> No records found</b>
    </h5>
  </tr>
</ng-template>
</p-table>